import Box from '@mui/material/Box';
import { FC, memo } from 'react';

import Grid2 from '../../grid/Grid2';
import Paragraph from '../../paragraph/Paragraph';
import Route from '../../route/Route';
import Video from '../../video/Video';
import ConditionalText from './ConditionalText';
import { ContentProps } from './type';

const DesktopContent: FC<ContentProps> = ({
  card: { shop, texts, texts1, texts2, texts3, video },
}) => (
  <Grid2 spacing='2rem'>
    <Grid2.Item>
      {texts && <ConditionalText texts={texts} />}
      {texts1 && <ConditionalText texts={texts1} />}
      {texts2 && <ConditionalText texts={texts2} />}
      {texts3 && <ConditionalText texts={texts3} />}
    </Grid2.Item>
    <Grid2.Item>
      {shop && (
        <Box sx={{ marginBottom: '1.5rem', textAlign: 'center' }}>
          {shop.video && <Video horizontal={shop.video.horizontal} mobile src={shop.video.src} />}
          <Paragraph>
            Mehr dazu in unserem <Route href={shop.href}>Online Shop</Route>.
          </Paragraph>
        </Box>
      )}
      {video && (
        <Box>
          <Video horizontal={video.horizontal} mobile src={video.src}></Video>
        </Box>
      )}
    </Grid2.Item>
  </Grid2>
);

export default memo(DesktopContent);
